export default "__VITE_ASSET__af1069fb__"